import React from 'react'
import { formatLocal } from 'utils/date'
import { translate } from 'locales'

// Styles
import { Title, TextArea } from 'components'
import useStorage from 'hooks/storageSync'
import * as S from './styles'

// Interfaces
import { IComponentProps } from './interfaces'

const ComplementarExams: React.FunctionComponent<IComponentProps> = ({
  doctorName,
  scheduleUUID,
}) => {
  const [storage, setStorage]: any = useStorage(
    scheduleUUID,
    'complementarExams'
  )

  // Recupera os valores salvos no storage para a consulta atual na sessão Conduct
  const dataStorage: any = storage?.complementarExams

  const handleChange = (key: string, e: string) => {
    setStorage(key, e)
  }

  return (
    <S.SectionContent>
      <span>{formatLocal(new Date(), 'EEEE, dd/MM/yyyy')}</span>
      <p>{`${translate('medicalRecord.by')} ${doctorName}`}</p>
      <div className="subsection">
        <Title text={translate('medicalRecord.complementarExams')} />
        <div className="subsection-item">
          <TextArea
            value={dataStorage?.exams}
            name="exams"
            rows={10}
            wrap="hard"
            onChange={(e: any) => handleChange(e.target.name, e.target.value)}
            placeholder={translate('medicalRecord.describe')}
          />
        </div>
      </div>
    </S.SectionContent>
  )
}

export default ComplementarExams
